import { render, staticRenderFns } from "./AssignStudentLookup.vue?vue&type=template&id=cc011a82&"
import script from "./AssignStudentLookup.vue?vue&type=script&lang=js&"
export * from "./AssignStudentLookup.vue?vue&type=script&lang=js&"
import style0 from "./AssignStudentLookup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports